export default __webpack_public_path__ + "static/media/CRS_7121-HDR-min.fb0ecc1b.jpg";